/**
 * Configuración del video de fondo del hero.
 *
 * Hay dos caminos y el componente elige solo:
 *
 * 1. RECOMENDADO — video propio alojado en el sitio.
 *    Deja el archivo en `public/video/hero.mp4` y apunta aquí.
 *    Es la mejor opción: sin JavaScript de terceros, sin cookies de
 *    YouTube, el bucle es exacto y no hay marca de agua.
 *    Ideal: 1920x1080, H.264, ~40 s en bucle, 4-8 MB, SIN audio.
 *
 * 2. FALLBACK — el video de YouTube que ya usaba el sitio.
 *    Se usa la IFrame API porque es la única forma de cortar el bucle
 *    antes del final; el script se carga después del primer pintado.
 */
export const HERO_VIDEO_MP4: string | null = null;

/** Se usa solo si HERO_VIDEO_MP4 es null. */
export const HERO_VIDEO_YOUTUBE_ID = '5ntvqful2Oc';

/**
 * Segundo en el que se reinicia el bucle.
 *
 * El video dura unos 47 s pero el cierre (los últimos segundos) no
 * funciona como fondo, así que se rebobina antes de llegar ahí.
 */
export const HERO_VIDEO_LOOP_AT = 42;

/** Imagen que se ve mientras el video carga y en conexiones lentas. */
export const HERO_POSTER = '/images/Wally.jpg';

/**
 * Un solo número para todo el sitio: el que se muestra, el que se marca y el
 * de WhatsApp. Es distinto del de kuva.com.co a propósito, para que Google no
 * vea dos negocios con el mismo teléfono.
 * Fuera de este archivo queda en index.html (JSON-LD) y en public/llms.txt.
 */
export const PHONE_E164 = '+573215518719';
export const PHONE_DISPLAY = '+57 321 551 8719';
export const WHATSAPP_NUMBER = '573215518719';
export const CONTACT_EMAIL = 'gcomercial@cabinadefotos.com.co';
export const INSTAGRAM_URL = 'https://instagram.com/kuvaphotobooth';
export const FACEBOOK_URL = 'https://www.facebook.com/kuvaphotobooth';
export const TIKTOK_URL = 'https://www.tiktok.com/@kuvaphotobooth';

/**
 * Survey de GoHighLevel para la página de contacto.
 * Vacío = se sigue mostrando el formulario que abre WhatsApp.
 * Al pegar aquí el id (el de la URL /widget/survey/<id>) la tarjeta de
 * contacto pasa a mostrar el survey. No cambia URLs, títulos ni el resto del
 * contenido de /contacto, así que no afecta la indexación.
 */
export const GHL_SURVEY_ID: string = '2TPELnUTfABpG1XFNv1z';
